import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import Alpine from 'alpinejs';

// Import components
import accordions from './components/accordions';
import accountMain from './components/account/account-main';
import accountPopup from './components/account/account-popup';
import accountRegister from './components/account/account-register';
import body from './components/body';
import cart from './components/cart';
import collection from './components/collection-main';
import countdown from './components/countdown';
import countryPopup from './components/country-popup';
import freeShippingProgress from './components/free-shipping-progress';
import header from './components/header';
import locationSelector from './components/location-selector';
import duftnoten from './components/pdp/duftnoten';
import product from './components/pdp/product-main';
import productRecommendation from './components/pdp/product-recommendations';
import productSet from './components/pdp/product-set';
import productVideo from './components/pdp/product-video';
import productRecent from './components/pdp/recent-product';
import predictiveSearch from './components/predictive-search';
import productCard from './components/product-card';
import search from './components/search-main';
import featuredBlog from './components/sliders/featured-blog';
import featuredProducts from './components/sliders/featured-products';
import hero from './components/sliders/hero';
import instaSlider from './components/sliders/instafeed';
import storeLocator from './components/store-locator';
import blog from './components/blog';
import clickableStars from './components/clickable-stars';
import quoteSlider from './components/sliders/quote-slider';
import bis from './components/bis';
import giftCard from './components/pdp/product-gift-card';
import cartDrawer from './components/cart-drawer';
import quickBuy from './components/quick-buy';
import testimonialsSlider from './components/sliders/testimonials-slider';
import tabSlider from './components/sliders/tabs-slider';

Alpine.plugin(collapse);
Alpine.plugin(persist);

// Declare components
Alpine.data('body', body);
Alpine.data('cart', cart);
Alpine.data('collection', collection);
Alpine.data('product', product);
Alpine.data('productVideo', productVideo);
Alpine.data('duftnoten', duftnoten);
Alpine.data('productSet', productSet);
Alpine.data('header', header);
Alpine.data('accordions', accordions);
Alpine.data('productRecommendation', productRecommendation);
Alpine.data('productRecent', productRecent);
Alpine.data('hero', hero);
Alpine.data('featuredProducts', featuredProducts);
Alpine.data('featuredBlog', featuredBlog);
Alpine.data('instaSlider', instaSlider);
Alpine.data('predictiveSearch', predictiveSearch);
Alpine.data('search', search);
Alpine.data('accountPopup', accountPopup);
Alpine.data('accountRegister', accountRegister);
Alpine.data('accountMain', accountMain);
Alpine.data('freeShippingProgress', freeShippingProgress);
Alpine.data('storeLocator', storeLocator);
Alpine.data('countryPopup', countryPopup);
Alpine.data('locationSelector', locationSelector);
Alpine.data('productCard', productCard);
Alpine.data('countdown', countdown);
Alpine.data('blog', blog);
Alpine.data('clickableStars', clickableStars);
Alpine.data('quoteSlider', quoteSlider);
Alpine.data('bis', bis);
Alpine.data('giftCard', giftCard);
Alpine.data('cartDrawer', cartDrawer);
Alpine.data('quickBuy', quickBuy);
Alpine.data('testimonialsSlider', testimonialsSlider);
Alpine.data('tabSlider', tabSlider);

window.Alpine = Alpine;
Alpine.start();
